import Vue from 'vue'
import Vuex from 'vuex'
import {getNotifications, getReminders, getUserAvoidEmailsOptions} from '@/helpers/api/general'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		loadingNotifications: true,
		badgeText: '--',
		badgeColor: '#cacaca',
		notifications: [],
		reminders: [],
		userAvoidEmailsOptions: null
	},
	mutations: {
		setNotifications(state, notifications){
			state.notifications = notifications
		},
		setReminders(state, reminders){
			state.reminders = reminders
		},
		setLoadingNotifications(state, status){
			state.loadingNotifications = status
		},
		setBadgeText(state, text){
			state.badgeText = text
		},
		setBadgeColor(state, color){
			state.badgeColor = color
		},
		setUserAvoidEmailsOptions(state, value){
			state.userAvoidEmailsOptions = value
		},
		resetForProject(state){
			state.userAvoidEmailsOptions = null
		},
	},
	actions: {
		async getNotifications(context){
			context.commit('setLoadingNotifications', true)
			const notifications = await getNotifications()
			if(notifications.code === 200){
				context.commit('setNotifications', notifications.notifications)
				context.commit('setLoadingNotifications', false)
				context.commit('setBadgeText', notifications.total_count.toString())

        let badge_color = 'success'
        if(notifications.total_count >= 5){
            badge_color = '#fb8c00'
        }
        if(notifications.total_count >= 10){
            badge_color = '#F4516C'
        }

				context.commit('setBadgeColor', badge_color)
			}
		},
		async getReminders(context){
			const reminders = await getReminders()
			if(reminders.code === 200){
				context.commit('setReminders', reminders.reminders)
			}
		},
		async getEmailNotificationsOptions(context, payload){
			const request = getProjectRequest(payload.project_id)
			const options = await getUserAvoidEmailsOptions(payload)
			if(isCurrentProjectRequest(request.projectId, request.generation) && options.code === 200){
				context.commit('setUserAvoidEmailsOptions', options.options)
			}
		}
	}
})

export default store